import {SxProps, Theme} from '@mui/material';

import {empionGreen} from '../../../../layouts/theme/EmpionColors';

export const PROFILE_DIALOG_SX: SxProps<Theme> = {
  '& .MuiDialog-paper': {
    width: '100%',
    borderRadius: '16px',
  },
  '& .MuiDialogContent-root': {
    padding: {xs: '1rem', sm: '1.5rem 2rem 2rem'},
  },
};

export const PROFILE_DIALOG_TITLE_SX: SxProps<Theme> = {
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: 1.4,
  color: empionGreen[700],
};

export const PROFILE_SWITCH_SX: SxProps<Theme> = {
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: empionGreen[700],
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: empionGreen[700],
  },
};
